import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { LOJ_COLORS } from '../theme/lojTheme';

interface OrnamentalDividerProps {
  label?: string;
  color?: string;
}

const OrnamentalDivider: React.FC<OrnamentalDividerProps> = ({
  label,
  color = LOJ_COLORS.goldBright,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        my: 3,
      }}
    >
      <Box
        sx={{
          flex: 1,
          height: '1px',
          background: `linear-gradient(to right, transparent, ${alpha(color, 0.8)}, ${alpha(color, 0.4)})`,
        }}
      />
      {label && (
        <Typography
          variant="subtitle1"
          sx={{
            color,
            fontSize: '0.7rem',
            letterSpacing: '0.2em',
            whiteSpace: 'nowrap',
            px: 1,
          }}
        >
          ✦ {label.toUpperCase()} ✦
        </Typography>
      )}
      {!label && (
        <Box sx={{ color, fontSize: '1rem', lineHeight: 1, opacity: 0.8 }}>
          ✦
        </Box>
      )}
      <Box
        sx={{
          flex: 1,
          height: '1px',
          background: `linear-gradient(to left, transparent, ${alpha(color, 0.8)}, ${alpha(color, 0.4)})`,
        }}
      />
    </Box>
  );
};

export default OrnamentalDivider;
